export default "__VITE_ASSET__uj0t7Eus__"